import script from "./NavBarSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBarSearch.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__